export default {
  title01: "当前天气",
  title02: "24小时",
  title03: "查看10天天气预报",
  title04: "空气质量指数（AQI）",
  title05: "查看所有信息",
  title06: "日出与日落",
  title07: "月相",
  title08: "下一个满月",
  title09: "下一个新月",
  title10: "白天",
  title11: "夜晚",
  title12: "日出",
  title13: "日落",
  title14: "月出",
  title15: "月落",
  title16: "来源",
  title17: "开始",
  title18: "结束",
  title19: "使用当前位置",
  title20: "搜索城市",
  title21: "体感温度",
  title22: "阴影体感温度",
  title23: "现在",
  title24: "今天",
  title25: "星期日",
  title26: "星期一",
  title27: "星期二",
  title28: "星期三",
  title29: "星期四",
  title30: "星期五",
  title31: "星期六",
  title32: "加载中...",
  title33: "现在",
  title34: "每小时",
  title35: "每日",
  title36: "日与月",
  title37: "空气质量",
  title38: "联系邮箱：xlf550402@gmail.com",
  title39: "隐私协议",
  title40: "版权 © comfortweather.com 2020 - 2026. 保留所有权利。",
  title41: "数据由 [LOGO] 提供",
  title42: "最高温度",
  title43: "最低温度",
  title44: "接受",
  title45: "感谢您使用 ComfortWeather！为更好地保护您的合法权益，请在使用前仔细阅读",
  title46: "《隐私政策》",
  title47: " 。",
  title48: "",
  title49: "联系邮箱：xyjph123@gmail.com",
  title50: "版权 © 24hweather.com 2020 - 2026. 保留所有权利。",
  title51: "感谢您使用 24hweather！为更好地保护您的合法权益，请阅读",
  title52: "您当前位置已更改，是否更新？",
  title53: "确认",
  title54: "取消",
  title55: "返回",
  title56: "新闻",
  title57: "正在更新天气...",
  title58: "天气已更新",
  title59: "查看全部",
  title60: "版权 © mobi321.com 2020 - 2026. 保留所有权利。",
  title61: "昨天",
  title62: "明天",
  title63: "15天天气预报",
  title64: "今日详情",
  title65: "Rahu Kaal",
  title66: "生活指数",
  title67: "生活指数",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "难以晾干",
  title103: "干得较慢",
  title104: "易于晾干",
  title105: "快速晾干",
  title106: "极速晾干",

  title107: "不适合",
  title108: "一般体验",
  title109: "适合水上活动",
  title110: "非常适合",
  title111: "完美条件",

  title112: "有利健康",
  title113: "风险正常",
  title114: "感冒概率上升",
  title115: "感冒易发",
  title116: "极易感冒",

  title117: "不适合",
  title118: "部分适合",
  title119: "适合户外活动",
  title120: "非常适合",
  title121: "优良条件",

  title122: "极易干燥",
  title123: "容易干燥",
  title124: "可能略干",
  title125: "不太干燥",
  title126: "非常滋润",

  title127: "不推荐",
  title128: "可接受",
  title129: "适合",
  title130: "非常适合",
  title131: "理想状况",

  title132: "皮肤干燥指数",
  title133: "感冒风险指数",
  title134: "洗车指数",
  title135: "户外活动指数",
  title136: "晾晒指数",
  title137: "戏水指数（海边/泳池）",

  title138: "厚羽绒衣毛衣毛裤手套围巾",
  title139: "羽绒衣毛衣毛裤手套",
  title140: "长袖毛衣风衣",
  title141: "长袖薄外套",
  title142: "长袖长裤",
  title143: "半袖短裙",

  title144: "非常不适宜旅游",
  title145: "不太适宜旅游",
  title146: "较适宜旅游",
  title147: "适宜旅游",
  title148: "非常适宜旅游",

  title149: "感冒可能性极低",
  title150: "感冒可能性低",
  title151: "感冒可能性一般",
  title152: "感冒可能性高",
  title153: "感冒可能性极高",

  title154: "非常不适宜运动",
  title155: "不太适宜运动",
  title156: "较适宜运动",
  title157: "适宜运动",
  title158: "非常适宜运动",

  title159: "需要使用防晒霜、帽子、长袖（建议中午不要出门）",
  title160: "不需要防晒",
  title161: "较需要防晒",
  title162: "需要防晒",
  title163: "非常需要防晒",

  title164: "非常不适宜洗车",
  title165: "不太适宜洗车",
  title166: "较适宜洗车",
  title167: "适宜洗车",
  title168: "非常适宜洗车",
};
